export default class OrderList {
  constructor(list) {
    this.list = list || []
  }
  /**
   * adds item
   * @param {Order} item 
   */
  add(item) {
    this.list.push(item)
  }
  /**
   * remove item
   * @param {Order} item 
   */
  remove(item) {
    let idx = this.list.indexOf(item)
    if (~idx) {
      this.list.splice(idx, 1)
    }
  }
  /**
   * finds an item by attr
   * @param {String} attr 
   * @param {*} value 
   */
  findByAttr(attr, value) {
    return this.list.find((item) => item[attr] == value)
  }
  /**
   * filters items by attr
   * @param {String} attr 
   * @param {*} value 
   */
  filterByAttr(attr, value) {
    return this.list.filter((item) => item[attr] == value)
  }
  /**
   * get clone of this list
   */
  getList() {
    return this.list.slice()
  }
  /**
   * get the difference of 2 lists
   * @param {String} attr 
   * @param {Array} otherList 
   */
  getListDifferenceByAttr(attr, otherList) {
    return this.list.filter((item) => { 
      return !otherList.find((otherItem) => item[attr] == otherItem[attr]) 
    })
  }
  /**
   * reset list
   */
  reset() {
    this.list = []
  }
}